import {
  Form,
  Image,
  Input,
  message,
  Modal,
  Select,
  Transfer,
  TransferProps,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  useGetVCEByOrderId,
  useUpdateOrder,
  useUpdateOrderStatus,
} from "../../api/order";
// import { useAddVCEOrder, useGetVCEByOrderId, useOrderDetail, useUpdateOrder } from '../../../api/order';

type AdminUdateOrderModalProps = {
  open: boolean;
  selectedId: string;
  orderStatus:
    | "ACCEPTED"
    | "DELIVERED"
    | "INPROGRESS"
    | "PENDING"
    | "REJECTED"
    | "COMPLETED"
    | undefined;
  hideModal: () => void;
};

interface RecordType {
  key: string;
  title: string;
  disabled: boolean;
  avatar_url: string | null;
}

const AdminUdateOrderModal: React.FC<AdminUdateOrderModalProps> = ({
  open,
  orderStatus,
  selectedId,
  hideModal,
}) => {
  const [status, setStatus] = useState<
    | "ACCEPTED"
    | "DELIVERED"
    | "INPROGRESS"
    | "PENDING"
    | "REJECTED"
    | "COMPLETED"
    | undefined
  >();
  const { data: orderDetail } = useGetVCEByOrderId(selectedId);

  const [source, setSource] = useState<RecordType[]>([]);

  const { mutateAsync: updateOrder, isPending } = useUpdateOrderStatus();

  const onsubmit = async () => {
    try {
      const result = await updateOrder({
        orderId: selectedId,
        status: status?.toString(),
      });

      if (result.status === 200) {
        message.success("Update successfull.");
      }
    } catch (err: any) {
      message.error("Operation failed.");
    } finally {
      hideModal();
    }
  };

  useEffect(() => {
    if (orderStatus) {
      setStatus(orderStatus);
    }
  }, [orderStatus]);

  useEffect(() => {
    if (orderDetail && orderDetail.data && orderDetail.data.data) {
      if (orderDetail.data) {
        const _target: React.Key[] = orderDetail.data.data.map(
          (o: any) => o.id,
        );

        setTargetKeys(_target);
      }
    }
  }, [orderDetail]);

  const [targetKeys, setTargetKeys] = useState<React.Key[]>();
  const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
  const [disabled, setDisabled] = useState(false);

  const handleChange: TransferProps["onChange"] = (
    newTargetKeys,
    direction,
    moveKeys,
  ) => {
    setTargetKeys(newTargetKeys);
  };

  const handleSelectChange: TransferProps["onSelectChange"] = (
    sourceSelectedKeys,
    targetSelectedKeys,
  ) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };

  const handleScroll: TransferProps["onScroll"] = (direction, e) => {};

  const handleDisable = (checked: boolean) => {
    setDisabled(checked);
  };

  return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 27.43,
            color: "black",
          }}
        >
          Edit order
        </div>
      }
      open={open}
      centered
      onOk={onsubmit}
      okButtonProps={{
        disabled: isPending,
        loading: isPending,
      }}
      onCancel={hideModal}
      closable
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <Select
          value={status}
          placeholder="Select category"
          style={{ width: "100%" }}
          onChange={(val: any) => setStatus(val)}
          options={[
            "ACCEPTED",
            "COMPLETED",
            "DELIVERED",
            "INPROGRESS",
            "PENDING",
            "REJECTED",
          ].map((_status: string) => {
            return { label: _status, value: _status };
          })}
        />
        {/* <div style={{ color: 'black', fontFamily: 'Poppins', fontSize: 20, alignSelf: 'center' }}>Value chain executors</div>
                    <Transfer
                        dataSource={source}
                        titles={['Available', 'Assigned']}
                        targetKeys={targetKeys}
                        selectedKeys={selectedKeys}
                        onChange={handleChange}
                        onSelectChange={handleSelectChange}
                        onScroll={handleScroll}
                        render={(item) => <div style={{
                            display: 'flex',
                            color: 'black',
                            alignItems: 'center',
                            gap: 12
                        }}>
                            {item.avatar_url && <Image preview={false} src={item.avatar_url} width={40} height={40} style={{ borderRadius: 40 }}  />}
                            {item.title}</div>}
                        disabled={disabled}
                        oneWay
                        // showSearch
                        showSelectAll={false}
                        style={{ marginBottom: 16, alignSelf: 'center' }}
                    /> */}
      </div>
    </Modal>
  );
};

export default AdminUdateOrderModal;
